import SpriteSymbol from "../../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "aggregation_sum_abs",
  "use": "aggregation_sum_abs-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"aggregation_sum_abs\"><path d=\"M0 0v6h14V0H0zm12.5 4.5h-11v-3h11v3zM0 14h14V8H0v6zm1.5-4.5h11v3h-11v-3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol